import { formatCodeName } from './utils'

/**
 * S34 (RN10.2/RN01.4): build the reference passed to the "Job" documents accordion, identifying
 * the selected node by its own code+name — never `node.name` alone, since that is now the free
 * descriptive field (often empty).
 * @param {import('../../generic/utilities/objectStructures/workflow/workflow').Node} node
 * @param {string} workflowName Container workflow identifier (workflow.code)
 * @returns {{id: number, code: string, name: string}}
 */
export const buildLinkedJobDocumentReference = (node, workflowName) => ({
  id: node.jobReference.id,
  code: node.code,
  name: workflowName + '   ||   ' + formatCodeName(node.code, node.name)
})

/**
 * S34 (RN10.2/RN01.4): build the Instructions dialog title, identifying the selected node by its
 * own code+name.
 * @param {function(string): string} t_ Translation function
 * @param {import('../../generic/utilities/objectStructures/workflow/workflow').Node} node
 * @param {string} taskName
 * @returns {string}
 */
export const buildInstructionsDialogTitle = (t_, node, taskName) =>
  t_('Instructions') + ' - ' + formatCodeName(node.code, node.name) + ' - ' + taskName
